import AllowedCountriesSelect from "./AllowedCountriesSelect";

export default AllowedCountriesSelect;